import { isAfter } from 'date-fns';
import { DesignVsMeetingHaug, MovingEditingHaug, PrivateWritingHaug } from '../../../@resources/help';
import { ActiveObject, resolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { ParticipantManager } from '../../canvas/participants/ParticipantManager';
import { HelpController } from '../../core/help/HelpController';
import { HelpTip } from '../../core/help/HelpTip';
import { PreferencesModel } from '../../preferences/PreferencesModel';

const newUserWelcomeTip = HelpTip(
    'newWelcome',
    'videos',
    'Welcome to Ludi!',
    'Before you begin, in here you can find Tutorial Videos for the app. ' +
    'We\'ve recommended a few for you to watch to get you started!'
);

export class HaugBehaviors extends ActiveObject {

    @resolve(ProfileModel) private me!: ProfileModel;
    @resolve(HelpController) private help!: HelpController;
    @resolve(ParticipantManager) private participants!: ParticipantManager;
    @resolve(PreferencesModel) private preferences!: PreferencesModel;

    public start(): void {
        this.scheduler.timeout('haug', 2000, () => {
            if (isAfter(this.me.createdAt, new Date('2023-05-01'))) {
                this.preferences.haug && this.help.openTip(newUserWelcomeTip);
                this.help.recommendVideo(MovingEditingHaug);
                this.help.recommendVideo(DesignVsMeetingHaug);
                this.help.recommendVideo(PrivateWritingHaug);
            }
        });
    }
}
